// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"557":"f550918f","581":"2e771b7c"}[chunkId] + ".chunk.js";
};